import { SecureLoader } from "@ews-admin/global-design-system";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSessionExpiration } from "../../hooks/useSessionExpiration";
import { validateSessionRequest } from "../../store/reducers/sessionSlice";
import { RootState } from "../../store/types";
import { storeQueryParams } from "../../utils/session-utils";

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.session);

  // Monitor session expiration
  useSessionExpiration();

  useEffect(() => {
    storeQueryParams();
    dispatch(validateSessionRequest());
  }, [dispatch]);
  console.log({ loading });
  // Show loading while session is being validated
  if (loading) {
    return <SecureLoader label={t("common.loading")} />;
  }
  return <>{children}</>;
};
